import { Info, List, Wrapper } from "template/ListTemplate.style";
import swapSummaryColumn from "./swapSummaryColumn.json";
import SwapSummaryDetail from "./SwapSummaryDetail/SwapSummaryDetail";

// 브릿지 -> 스왑 :: 요약 (http://localhost:3000/super/bridge/swap)
const SwapSummary = ({ swapList }) => {
  return (
    <Wrapper>
      <List.TitleContainer>
        <List.Text>스왑 내역 요약</List.Text>
        <List.BtnContainer></List.BtnContainer>
      </List.TitleContainer>

      <List.Container style={{ minHeight: "0" }}>
        <List.Content>
          {swapSummaryColumn?.summary.map((v, idx) => (
            <List.Row $ratio={v.ratio} key={idx}>
              {v.title}
            </List.Row>
          ))}
        </List.Content>

        <Info.Wrapper>
          <SwapSummaryDetail data={swapList.summary} />
        </Info.Wrapper>
      </List.Container>
    </Wrapper>
  );
};

export default SwapSummary;
